import React from 'react'
import styled from '@emotion/styled'
import shouldUpdate from 'recompose/shouldUpdate'
import { spacer } from 'stylist'

const MicrosoftLogoSVG = styled.svg`
  height: ${spacer(5)};
  width: ${spacer(5)};
`

const MicrosoftLogo = () => (
  <MicrosoftLogoSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 440 440">
    <title>Microsoft</title>
    <rect fill="#F3F3F3" width="439" height="439" />
    <rect fill="#F35325" x="17" y="17" width="194" height="194" />
    <rect fill="#81BC06" x="228" y="17" width="194" height="194" />
    <rect fill="#05A6F0" x="17" y="228" width="194" height="194" />
    <rect fill="#FFBA08" x="228" y="228" width="194" height="194" />
  </MicrosoftLogoSVG>
)

export default shouldUpdate(() => false)(MicrosoftLogo)



// WEBPACK FOOTER //
// ./src/images/MicrosoftLogo.js